var emojis = {
  "set1": [
    {
      "symbol": "smiley",
      "image": "https://cdn0.pepper.ru/static/images/emojis/smiley.png"
    },
    {
      "symbol": "thumb",
      "image": "https://cdn1.pepper.ru/static/images/emojis/thumb.png"
    },
    {
      "symbol": "happy",
      "image": "https://cdn2.pepper.ru/static/images/emojis/happy.png"
    },
    {
      "symbol": "laugh",
      "image": "https://cdn3.pepper.ru/static/images/emojis/laugh.png"
    },
    {
      "symbol": "lol",
      "image": "https://cdn0.pepper.ru/static/images/emojis/lol.png"
    },
    {
      "symbol": "popcorn",
      "image": "https://cdn1.pepper.ru/static/images/emojis/popcorn.png"
    },
    {
      "symbol": "relieved",
      "image": "https://cdn2.pepper.ru/static/images/emojis/relieved.png"
    },
    {
      "symbol": "angel",
      "image": "https://cdn3.pepper.ru/static/images/emojis/angel.png"
    },
    {
      "symbol": "wink",
      "image": "https://cdn1.pepper.ru/static/images/emojis/wink.png"
    },
    {
      "symbol": "cheeky",
      "image": "https://cdn1.pepper.ru/static/images/emojis/cheeky.png"
    },
    {
      "symbol": "embarrassed",
      "image": "https://cdn2.pepper.ru/static/images/emojis/embarrassed.png"
    },
    {
      "symbol": "love",
      "image": "https://cdn3.pepper.ru/static/images/emojis/love.png"
    },
    {
      "symbol": "party",
      "image": "https://cdn0.pepper.ru/static/images/emojis/party.png"
    },
    {
      "symbol": "tongue",
      "image": "https://cdn1.pepper.ru/static/images/emojis/tongue.png"
    },
    {
        "symbol": "highfive",
        "image": "https://cdn2.pepper.ru/static/images/emojis/highfive.png"
    },
    {
      "symbol": "cool",
      "image": "https://cdn3.pepper.ru/static/images/emojis/cool.png"
    },
    {
      "symbol": "sir",
      "image": "https://cdn0.pepper.ru/static/images/emojis/sir.png"
    },
    {
      "symbol": "nerd",
      "image": "https://cdn1.pepper.ru/static/images/emojis/nerd.png"
    },
    {
      "symbol": "ninja",
      "image": "https://cdn2.pepper.ru/static/images/emojis/ninja.png"
    },
    {
      "symbol": "pirate",
      "image": "https://cdn3.pepper.ru/static/images/emojis/pirate.png"
    },
    {
      "symbol": "blank",
      "image": "https://cdn0.pepper.ru/static/images/emojis/blank.png"
    },
    {
      "symbol": "confused",
      "image": "https://cdn1.pepper.ru/static/images/emojis/confused.png"
    },
    {
      "symbol": "skeptical",
      "image": "https://cdn2.pepper.ru/static/images/emojis/skeptical.png"
    },
    {
      "symbol": "annoyed",
      "image": "https://cdn3.pepper.ru/static/images/emojis/annoyed.png"
    },
    {
      "symbol": "sad",
      "image": "https://cdn0.pepper.ru/static/images/emojis/sad.png"
    },
    {
      "symbol": "mad",
      "image": "https://cdn1.pepper.ru/static/images/emojis/mad.png"
    },
    {
      "symbol": "fierce",
      "image": "https://cdn2.pepper.ru/static/images/emojis/fierce.png"
    },
    {
      "symbol": "shock",
      "image": "https://cdn3.pepper.ru/static/images/emojis/shock.png"
    },
    {
      "symbol": "horror",
      "image": "https://cdn0.pepper.ru/static/images/emojis/horror.png"
    },
    {
      "symbol": "worried",
      "image": "https://cdn2.pepper.ru/static/images/emojis/worried.png"
    },
    {
      "symbol": "cry",
      "image": "https://cdn2.pepper.ru/static/images/emojis/cry.png"
    },
    {
      "symbol": "woot",
      "image": "https://cdn3.pepper.ru/static/images/emojis/woot.png"
    },
    {
      "symbol": "poo",
      "image": "https://cdn0.pepper.ru/static/images/emojis/poo.png"
    },
    {
      "symbol": "devil",
      "image": "https://cdn1.pepper.ru/static/images/emojis/devil.png"
    },
    {
      "symbol": "kitty",
      "image": "https://cdn2.pepper.ru/static/images/emojis/kitty.png"
    },
    {
      "symbol": "zombie",
      "image": "https://cdn3.pepper.ru/static/images/emojis/zombie.png"
    }
  ]
}

export {emojis}